import { memo } from 'react';
import { formatNumber, NumeralFormatPattern } from 'utils/numberFormat';

export interface FormatNumberProps {
  number: number;
  format?: NumeralFormatPattern;
}

function FormatNumber(props: FormatNumberProps) {
  const { format = '0,0', number } = props;
  return <>{formatNumber(number, format)}</>;
}

export default memo(FormatNumber);
